import InfoIcon from '../../icons/InfoIcon'
import { cn } from '../../lib/cva'
import { MarkdownPreview } from '../MarkdownEditor'
import { Text } from '../Text'
import { Tooltip, TooltipContent, TooltipTrigger } from '../Tooltip'
import type { LabelSize } from './types'
import { getLabelVariant } from './utils'

export interface FormLabelWithTooltipProps {
	label: string
	labelColor?: string
	labelSize?: LabelSize
	labelWeight?: 'regular' | 'semibold' | 'hidden' | null
	required?: boolean
	readOnly?: boolean
	tooltipEnabled?: boolean
	tooltipText?: string
	variant?: 'default' | 'xsmall'
	className?: string
}

export function FormLabelWithTooltip({
	label,
	labelColor,
	labelSize,
	labelWeight,
	required,
	readOnly,
	tooltipEnabled,
	tooltipText,
	variant = 'default',
	className,
}: FormLabelWithTooltipProps) {
	if (!label || labelWeight === 'hidden') return null

	const showTooltip = tooltipEnabled && tooltipText?.trim()
	const textVariant = labelSize ? getLabelVariant(labelSize) : variant === 'xsmall' ? 'xsmall' : 'small'

	return (
		<div className={cn('inline-flex items-center gap-1', className)}>
			<Text variant={textVariant} style={{ color: labelColor }} weight={labelWeight || null}>
				{label} {required && !readOnly && <span>*</span>}
			</Text>
			{showTooltip && (
				<Tooltip>
					<TooltipTrigger asChild>
						<button type='button' aria-label='Help information'>
							<InfoIcon size={14} className='text-neutral-400 cursor-help hover:text-neutral-600' />
						</button>
					</TooltipTrigger>
					<TooltipContent side='top' className='max-w-xs bg-white border shadow-lg px-3 py-2'>
						<MarkdownPreview markdown={tooltipText as string} className='text-xs' />
					</TooltipContent>
				</Tooltip>
			)}
		</div>
	)
}
